<template>
  <div class="wxWorkChat">
    <span v-if="selectName" style="padding: 0.2rem; display: block; line-height: 0.56rem">
      {{ selectName }} ---企业微信群
      <el-button-group style="float: right">
        <el-tooltip content="公司信息" placement="top" :open-delay="350" v-if="getedCompanyId.length > 0">
          <el-popover placement="bottom" width="300" trigger="hover" style="float: left">
            <div style="padding:,0.1rem 0.2rem;text-align: center">
              <p :title="item.company_name"
                style="margin-bottom:0.2rem;cursor: pointer;white-space: nowrap;overflow-x: hidden;text-overflow: ellipsis"
                v-for="item in getedCompanyId" :key="item.id" @click.prevent="handleOpenCompanyInfo(item.id)">
                {{ item.company_name }}
              </p>
            </div>
            <!-- <div style="padding:0.2rem 0.5rem;text-align: center" v-else>
              <span style="color: #E6A23C">该群未绑定公司!</span>
            </div> -->
            <el-button slot="reference" type="primary" size="mini" icon="el-icon-office-building"
              style="float: right"></el-button>
          </el-popover>
        </el-tooltip>
        <el-tooltip content="公司信息" placement="top" :open-delay="350" v-else>
          <el-button type="primary" size="mini" icon="el-icon-office-building"></el-button>
        </el-tooltip>
        <el-tooltip content="添加事项" placement="top" :open-delay="500">
          <el-button type="primary" size="mini" icon="el-icon-s-flag" @click="handleAddItemEntry"></el-button>
        </el-tooltip>
        <el-tooltip content="添加材料" placement="top" :open-delay="500">
          <el-button type="primary" size="mini" icon="el-icon-folder-add" @click="handleAddFiles"></el-button>
        </el-tooltip>
        <el-tooltip content="群信息" placement="top" :open-delay="500">
          <el-button type="primary" size="mini" icon="el-icon-info" @click="handleChatInfoOpen"></el-button>
        </el-tooltip>
      </el-button-group>
      <!--       <el-button type="primary" size="mini" style="float: right" @click="handleAddFiles">添加材料</el-button>
      <el-button type="primary" size="mini" style="float: right" @click="handleAddItemEntry">添加事项</el-button> -->
    </span>
    <el-row :gutter="20" v-if="selectName && !searchArr.betweenDate" style="padding-left: 0.2rem">
      <el-col :span="12">
        <el-date-picker size="mini" clearable v-model="searchArr.msgtime" type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          @change="searchMessages">
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        <el-input v-model="searchArr.content" size="mini" clearable placeholder="内容关键词"
          @input="handelContentchange"></el-input>
      </el-col>
    </el-row>
    <el-row v-if="selectName" style="margin: 10px 0; padding-left: 0.2rem">
      <el-col :span="24">
        <el-radio-group v-model="searchArr.msgtype" size="mini">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="text">文本</el-radio-button>
          <el-radio-button label="image">图片</el-radio-button>
          <el-radio-button label="file">文件</el-radio-button>
          <el-radio-button label="voice">语音</el-radio-button>
          <el-radio-button label="video">视频</el-radio-button>
          <el-radio-button label="link">链接</el-radio-button>
          <el-radio-button label="emotion">表情</el-radio-button>
          <el-radio-button label="weapp">小程序</el-radio-button>
          <el-radio-button label="external_redpacket">红包</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <div class="chat_content">
      <el-row class="chat_record_wrap" v-scroll-loading="scrollBottom" ref="messagesList">
        <div v-for="(message, index) in chatMessages" :key="index" class="record_item">
          <div class="record_user_head">
            <el-avatar shape="square" :size="45" fit="cover" :src="msgHead(message)"></el-avatar>
          </div>
          <div class="record_content ml-10">
            <div class="record_usernick">
              {{ msgNickName(message) }}
              <span style="padding-left: 10px" v-if="!message.storage_record">
                <el-checkbox :v-model="checkArr" :checked="is_checked"
                  @change="handleAddMessageIndex(message.msgid)"></el-checkbox>
              </span>
              <span style="padding-left: 20px" v-else>{{
                message.storage_record
              }}</span>
            </div>
            <div class="record_wrap">
              <div class="record" :class="[message.msgtype === 'text' ? 'reciver' : '']">
                <div v-if="message.msgtype === 'text'" class="recordText">
                  {{ message.content }}
                </div>
                <div v-else-if="message.msgtype === 'image'">
                  <el-image :class="[message.filesrc ? 'imgType' : 'imgerr']" :src="message.filesrc" fit="fill"
                    :preview-src-list="[message.filesrc]" lazy>
                    <div slot="error" class="image-slot" @click="handLoadMedia(index, message, 'PNG')">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div v-else-if="message.msgtype === 'voice'">
                  <div class="infinite-item-voice" @click="handLoadAmr(index, message, 'amr')">
                    <el-row>
                      <el-col :span="12">
                        <div class="wrap">
                          <div class="box" :class="[avtiveChat === index ? 'box-an' : '']">
                            <div class="box1">
                              <div class="box2" :class="{ 'box2-an': avtiveChat === index }">
                                <div class="box3">
                                  <div class="box4"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="12" class="tr">{{ message.play_length }}"</el-col>
                    </el-row>
                  </div>
                </div>
                <div v-else-if="message.msgtype === 'video'">
                  <el-image class="imgerr" fit="fill" lazy>
                    <div slot="error" class="image-slot video" @click="handLoadVideo(index, message, 'mp4')">
                      <i class="el-icon-video-play"></i>
                    </div>
                  </el-image>
                </div>
                <div v-else-if="message.msgtype === 'file'">
                  <div class="el-row infinite-item-file" @click="handLoadFile(index, message)">
                    <el-col :span="6">
                      <div class="infinite-file-icon">
                        <i class="el-icon-tickets"></i>
                      </div>
                    </el-col>
                    <el-col :span="18">
                      <div class="infinite-file-name">
                        <p class="hide-style">{{ message.filename }}</p>
                        <p class="infinite-file-size">{{ message.filesize }}</p>
                      </div>
                    </el-col>
                  </div>
                </div>
                <div v-else-if="message.msgtype === 'link'">
                  <el-card class="link" shadow="never">
                    <div slot="header">
                      <span>{{ message.title }}</span>
                    </div>
                    <div class="text item">
                      <el-row>
                        <el-col :span="19">
                          <span class="link-title">{{ message.link_url }}</span>
                        </el-col>
                        <el-col :span="5" class="text-align-c">
                          <el-image style="width: 50px" :class="[message.image_url ? 'imgType' : 'imgerr']"
                            :src="message.image_url" fit="fill" lazy>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                        </el-col>
                      </el-row>
                    </div>
                  </el-card>
                </div>
                <div v-else-if="message.msgtype === 'emotion'">
                  <el-image style="width: 120px" :src="message.filesrc" fit="fill" lazy>
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div v-else-if="message.msgtype === 'weapp'">
                  <el-card class="link" shadow="never">
                    <div slot="header">
                      <p style="margin-bottom: 0.2rem">
                        {{ message.displayname }}
                      </p>
                      <p>{{ message.title }}</p>
                    </div>
                    <div class="text item">
                      <p>小程序消息</p>
                    </div>
                  </el-card>
                </div>
                <div v-else-if="message.msgtype === 'external_redpacket'">
                  <el-card class="link" style="background-color: #e68472; color: rgb(245 233 221)" shadow="never">
                    <div>
                      <el-row>
                        <el-col :span="4">
                          <svg class="icon svg-icon" aria-hidden="true">
                            <use xlink:href="#youkai-hongbao"></use>
                          </svg>
                        </el-col>
                        <el-col :span="20" style="line-height: 0.8rem">
                          <span>{{ message.wish }}</span>
                        </el-col>
                      </el-row>
                    </div>
                    <el-divider></el-divider>
                    <p style="padding-left: 0.1rem; font-size: 12px">红包</p>
                  </el-card>
                </div>
              </div>
            </div>
            <div class="record_time">{{ message.msgtime }}</div>
          </div>
        </div>
      </el-row>
    </div>
    <!--     <el-row v-scroll-loading="scrollBottom" ref="messagesList" class="messages-list">
      <div class="messages-con">
        <div v-for="(message, index) in chatMessages" :key="index" class="infinite-list-item">
          <div v-if="message.from_type === 1">
            <el-image :src="message.employee ? message.employee.thumb_avatar : ''" style="width: 40px; height: 40px; vertical-align: middle;" fit="cover"></el-image>
            <span class="infinite-item-title">
              {{ message.employee ? message.employee.name : '???' }}
              <span class="infinite-item-title">{{ message.msgtime }}</span>
            </span>
            <span style="padding-left: 10px" v-if="!message.storage_record">
              <el-checkbox :v-model="checkArr" :checked="is_checked" @change="handleAddMessageIndex(message.msgid)"></el-checkbox>
            </span>
            <span style="padding-left: 20px" v-else>{{ message.storage_record }}</span>
          </div>
          <div v-else>
            <el-image :src="message.external ? message.external.avatar : ''" fit="fit" style="width: 45px; height: 45px; vertical-align: middle"></el-image>
            <span class="infinite-item-title">
              {{ message.external ? message.external.name : '???' }}
              <span class="infinite-item-title">{{ message.msgtime }}</span>
            </span>
            <span style="padding-left: 10px" v-if="!message.storage_record">
              <el-checkbox :checked="is_checked" @change="handleAddMessageIndex(message.msgid)"></el-checkbox>
            </span>
            <span style="padding-left: 20px" v-else>{{ message.storage_record }}</span>
          </div>
          <el-row class="mb-0">
            <el-col :span="24" v-if="message.msgtype === 'text'">
              <div class="infinite-item-content">{{ message.content }}</div>
               <div class="popper__arrow"></div>
            </el-col>
            <el-col :span="24" v-else-if="message.msgtype === 'image'" class="mt-10">
              <el-image :class="[message.filesrc ? 'imgType' : 'imgerr']" :src="message.filesrc" fit="fill" :preview-src-list="[message.filesrc]" lazy>
                <div slot="error" class="image-slot" @click="handLoadMedia(index, message, 'PNG')">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-col>
            <el-col :span="24" v-else-if="message.msgtype === 'voice'">
              <div class="infinite-item-voice" @click="handLoadAmr(index, message, 'amr')">
                <el-row>
                  <el-col :span="12">
                    <div class="wrap">
                      <div class="box" :class="[avtiveChat === index ? 'box-an' : '']">
                        <div class="box1">
                          <div class="box2" :class="{'box2-an': avtiveChat === index}">
                            <div class="box3"><div class="box4"></div></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" class="tr">{{message.play_length}}"</el-col>
                </el-row>
              </div>
              <div class="popper__arrow" style="border-bottom-color: rgb(191, 221, 253)"></div>
            </el-col>
            <el-col :span="24" v-else-if="message.msgtype === 'video'" class="mt-10">
              <el-image class="imgerr" fit="fill" lazy>
                <div slot="error" class="image-slot video" @click="handLoadVideo(index, message, 'mp4')">
                  <i class="el-icon-video-play"></i>
                </div>
              </el-image>
            </el-col>
            <el-col :span="24" v-else-if="message.msgtype === 'file'">
              <div class="el-row infinite-item-file" @click="handLoadFile(index, message)">
                <el-col :span="6">
                  <div class="infinite-file-icon"><i class="el-icon-tickets"></i></div>
                </el-col>
                <el-col :span="18">
                  <div class="infinite-file-name">
                    <p class="hide-style">{{message.filename}}</p>
                    <p class="infinite-file-size">{{message.filesize}}</p>
                  </div>
                </el-col>
              </div>
              <div class="popper__arrow"></div>
            </el-col>
            <el-col :span="24" v-else-if="message.msgtype === 'link'">
              <el-row>链接</el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-row> -->
    <el-dialog title="video" :visible.sync="videoVisible" width="40%" :before-close="handleVideoClose">
      <div>
        <video :src="videoSrc" controls="controls" width="100%" height="100"></video>
      </div>
    </el-dialog>
    <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" direction="rtl" size="50%" append-to-body>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyComId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer :visible.sync="serviceInDrawer" direction="rtl" size="40%" :append-to-body="true">
      <template slot="title">
        <span style="font-size: 0.38rem; font-weight: 700; color: #409eff">服务事项录入</span>
      </template>
      <ser-matt-in :ccoms="companies" :item="itemForm.item_content" :ffile="itemFiles" @close="closeDrawer"></ser-matt-in>
    </el-drawer>
    <el-drawer title="添加事项" :visible.sync="itemDrawer" :before-close="handleAddClose" direction="rtl"
      :append-to-body="true" size="40%">
      <div class="drawer-content">
        <el-form :model="itemForm" ref="itemForm" label-width="100px" size="mini">
          <el-form-item label="是否分配" prop="is_allot">
            <el-radio-group v-model="itemForm.is_allot" size="mini">
              <el-radio label="1" border>暂不分配</el-radio>
              <el-radio label="2" border>分配给办理人</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="公司名称" prop="company_id">
            <el-select v-model="itemForm.company_id" filterable remote reserve-keyword placeholder="请输入公司字号筛选公司"
              size="mini" clearable :remote-method="remoteCompanyMethod" :loading="loading">
              <el-option v-for="company in companies" :key="company.id" :label="company.company_name" :value="company.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单编号" prop="order_id">
            <el-select v-model="itemForm.order_id" filterable remote reserve-keyword placeholder="请输入订单号筛选订单（若无可不填写）"
              size="mini" clearable :remote-method="remoteOrderMethod" :loading="loading">
              <el-option v-for="order in orders" :key="order.id" :label="order.order_num" :value="order.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事项类型" prop="entries_type">
            <el-radio-group v-model="itemForm.entries_type" size="mini">
              <el-radio label="1" border>外勤</el-radio>
              <el-radio label="2" border>内勤</el-radio>
            </el-radio-group>
          </el-form-item>
          <span v-if="itemForm.is_allot === '2'">
            <el-form-item label="办理人" prop="user_id">
              <el-select v-model="itemForm.user_id" filterable placeholder="请选择办理人">
                <el-option v-for="item in users" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="办理时间" prop="handle_time">
              <el-date-picker style="width: 100%" v-model="itemForm.handle_time" type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="办理地点" prop="place_id" v-if="
              itemForm.entries_type === 1 || itemForm.entries_type === '1'
            ">
              <el-select v-model="itemForm.place_id" filterable placeholder="请选择办理地点">
                <el-option v-for="item in places" :key="item.id" :label="item.places_title" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </span>
          <el-form-item label="事项分类" prop="cates">
            <el-cascader v-model="itemForm.cates" placeholder="请选择创建事项的分类" :options="options" size="mini"
              style="width: 100%" :props="{ multiple: true }" filterable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="内容详情" prop="item_content">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
              v-model="itemForm.item_content">
            </el-input>
          </el-form-item>
        </el-form>
        <div style="padding-left: 2rem">
          <el-row>
            <el-col :span="24">
              <el-card shadow="hover">
                <el-upload multiple ref="upload" action="#" :headers="uploadHeader"
                  accept="image/png, image/jpeg, image/gif" :limit="5" :on-preview="handleLicensePreview"
                  :on-change="handleLicenseChange" :on-remove="handleLicenseRemove" :file-list="licenseList"
                  list-type="picture" :auto-upload="false">
                  <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
                </el-upload>
              </el-card>
            </el-col>
          </el-row>
          <el-row style="padding-top: 0.4rem">
            <el-input v-paste="handleParse" type="textarea" placeholder="请点击此处，再粘贴复制的截图" />
          </el-row>
        </div>
        <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button type="primary" size="mini" @click="submitAddUpload('itemForm')">添加</el-button>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="添加记账材料" :visible.sync="fileDrawer" :before-close="handleAddFileClose" direction="rtl"
      :append-to-body="true" size="40%">
      <div class="m-tabs-content">
        <div style="margin-bottom: 18px">
          <p style="
                                        display: inline-block;
                                        width: 68px;
                                        text-align: right;
                                        padding: 0 12px 0 0;
                                      ">
            文件
          </p>
          {{ getFileName() }}
        </div>
        <el-form ref="upForm" :rules="upRules" :model="upForm" label-width="80px" size="mini">
          <el-form-item label="公司" prop="cid">
            <el-select v-model="upForm.cid" placeholder="请选择公司">
              <el-option v-for="company in companies" :key="company.id" :label="company.company_name" :value="company.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件类型" prop="file_type">
            <el-select v-model="upForm.file_type" placeholder="请选择文件类型">
              <el-option label="工资申报表" :value="1"></el-option>
              <el-option label="开票汇总表" :value="2"></el-option>
              <el-option label="销项发票" :value="3"></el-option>
              <el-option label="银行回单" :value="4"></el-option>
              <el-option label="其他费用发票" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件来源" prop="file_source">
            <el-select v-model="upForm.file_source" placeholder="请选择文件来源">
              <el-option label="微信" :value="2"></el-option>
              <el-option label="qq" :value="3"></el-option>
              <el-option label="邮箱" :value="4"></el-option>
              <el-option label="网盘" :value="5"></el-option>
              <el-option label="小程序" :value="6"></el-option>
              <el-option label="其他" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="upForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <el-row style="text-align: right">
          <el-button type="primary" size="mini" @click="submitAddFiles('upForm')">添 加</el-button>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="bindDialog" append-to-body @close="clearSub">
      <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
        <el-form-item prop="orderNum" label="订单号" :rules="[
          { required: true, message: '请输入订单号', trigger: 'blur' }
        ]">
          <el-input v-model="dynamicValidateForm.orderNum" clearable size="mini"></el-input>
        </el-form-item>
        <el-form-item v-for="(domain, index) in dynamicValidateForm.domains" :label="'订单号' + index" :key="domain.key"
          :prop="'domains.' + index + '.value'" :rules="[{
            required: true, message: '订单号不能为空', trigger: 'blur'
          }]" style="white-space: nowrap;">
          <el-input v-model="domain.value" size="mini" clearable
            style="width:90%;margin-right:0.1rem"></el-input><el-button size="mini"
            @click.prevent="removeDomain(domain)">删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="submitForm('dynamicValidateForm')">提交</el-button>
          <el-button @click="addDomain" size="mini">新增订单号</el-button>
          <el-button size="mini" @click="resetForm('dynamicValidateForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="" :visible.sync="infoDialog" append-to-body @closed="closeSelf">
      <span slot="title" style="font-weight:bold;font-size:x-large;color:#409eff">绑定信息</span>
      <div class="import-info-style">
        <p style="color:#F56C6C;font-size:large;margin-top: 0.2rem;font-weight:bold;">以下订单绑定失败:</p>
        <div style="margin-top:0.2rem">
          <ul>
            <li v-for="(item, index) in errData" :key="index" style="margin-bottom: 0.2rem">
              <span style="font-weight:bold;font-size:medium">{{ item.order_num }} 已绑定在</span>
              <span style="font-weight:bold;font-size:medium">{{ item.chat_room }} </span>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
    <el-drawer title="群信息" :visible.sync="chatInfoDrawer" :before-close="handleChatInfoClose" direction="rtl"
      :append-to-body="true" size="50%">
      <div class="m-tabs-content">
        <p style="font-size: 0.4rem">
          {{ groupInfo.name }}
          <el-button type="primary" size="mini" style="float: right" @click="openBindDialog">绑定订单号</el-button>
        </p>
        <p style="margin-top: 0.2rem; color: grey; font-size: 0.26rem">
          群主：{{ ownerName }} | 创建时间：{{ groupInfo.create_time }}
        </p>
        <p style="margin-top: 0.2rem; color: grey; font-size: 0.26rem">
          <el-collapse v-if="groupInfo.notice">
            <el-collapse-item title="群公告">
              <p style="white-space: pre-wrap">{{ groupInfo.notice }}</p>
            </el-collapse-item>
          </el-collapse>
          <span v-else>群公告：未设置</span>
        </p>
        <el-table :data="groupInfo.members" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak>
          <el-table-column label="群成员">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.name" placement="top" :open-delay="500">
                <span class="hide-style">{{ scope.row.name
                }}<span style="color: #2db34a" v-if="scope.row.member_type === 2">
                    @微信</span></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="群昵称">
            <template slot-scope="scope">
              <el-tooltip :content="
                scope.row.group_nickname
                  ? scope.row.group_nickname
                  : scope.row.name
              " placement="top" :open-delay="500">
                <span class="hide-style">{{
                  scope.row.group_nickname
                  ? scope.row.group_nickname
                  : scope.row.name
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="进群时间">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.join_time" placement="top" :open-delay="500">
                <span class="hide-style">{{ scope.row.join_time }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="进群方式">
            <template slot-scope="scope">
              <el-tooltip :content="getJoinType(scope.row)" placement="top" :open-delay="500">
                <span class="hide-style">{{ getJoinType(scope.row) }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="
                                    color: black;
                                    font-size: x-large;
                                  text-align: center;
                                     margin: 0.5rem 0 1rem 0;
                                    font-weight: bold;
                                  ">
        聊天记录统计
      </div>
      <div class="mt-pd-2" style="margin-bottom: 0.2rem">
        <div style="
                                      display: flex;
                                      flex-direction: row;
                                      white-space: nowrap;
                                      overflow: auto;
                                    ">
          <div style="text-align: left">
            <el-date-picker v-model="member_count_chooise_date" type="datetimerange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="typeInPickerOptions"
              :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" size="mini"
              @change="handleGetMemberCount">
            </el-date-picker>
            <p>
              <i class="el-icon-s-opportunity" style="
                                            color: #e6a23c;
                                            font-size: x-small;
                                            display: block;
                                            margin-top: 0.1rem;
                                          ">没有选择日期默认是今天</i>
            </p>
          </div>
          <div style="margin-left: 0.2rem">
            <el-select v-model="filter_member_count" placeholder="少于多少条不展示？" size="mini" style="vertical-align: top"
              @change="HandleFilterMemberCount" clearable filterable>
              <el-option label="5" value="5"> </el-option>
              <el-option label="10" value="10"> </el-option>
              <el-option label="30" value="30"> </el-option>
              <el-option label="50" value="50"> </el-option>
            </el-select>
          </div>
          <div style="flex: 1; margin-left: 0.2rem">
            <el-radio-group v-model="groupOrPersonal" size="mini" @change="chooseChatType" style="float: right">
              <el-radio-button label="group">群聊</el-radio-button>
              <el-radio-button label="personal">私聊</el-radio-button>
              <el-radio-button label="all">全部</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div style="text-align: right; clear: both">
          <span class="fs-s" style="color: ; margin-left: 0.2rem">聊天总数：{{ chatTotal }}</span>
          <span class="fs-s" style="color: #409eff; margin-left: 0.1rem">我方：{{ chatOur }}</span>
          <span class="fs-s" style="color: #67c23a; margin-left: 0.1rem">客户：{{ chatCustomer }}</span>
          <!-- <span class="fs-s"
              style="color: #e6a23c; margin-left: 0.1rem"
              v-if="chatRobot > 0"
              >群机器人：{{ chatRobot }}</span
            > -->
        </div>
        <div>
          <span v-if="pieData.length > 0" style="
                                        display: inline-block;
                                        font-size: medium;
                                        color: black;
                                        font-weight: 700;
                                        margin-top: 0.8rem;
                                      ">我方数据:</span>
        </div>
      </div>
      <div id="mychart" :style="myChartStyle" style="clear: both; margin-top: 0.2rem"></div>
      <div>
        <div>
          <span v-if="customer_pieData.length > 0" style="
                                        display: inline-block;
                                      font-size: medium;
                                        color: black;
                                        font-weight: 700;
                                        margin-top: 0.8rem;
                                        margin-left: 0.2rem;
                                      ">客户数据:</span>
        </div>
      </div>
      <div id="customer_chart" :style="myChartStyle" style="clear: both; margin-top: 0.2rem"></div>
    </el-drawer>
  </div>
</template>

<script>
import CompanyInfo from 'common/CompanyInfo'
import * as echarts from 'echarts'
import SerMattIn from 'common/ServiceMatterInWx'
import BenzAMRRecorder from 'benz-amr-recorder'
var amr = new BenzAMRRecorder()
export default {
  name: 'WxWorkChat',
  components: { SerMattIn, CompanyInfo },
  props: {
    betweenDate: {
      type: String,
      default: () => {
        return ''
      }
    },
    chatId: {
      type: String,
      default: () => {
        return null
      }
    },
    chatName: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      infoDialog: false,
      errData: [],
      dynamicValidateForm: {
        domains: [],
        orderNum: ''
      },
      bindDialog: false,
      getedCompanyId: '',
      companyComId: '',
      companyInfoDrawer: false,
      groupOrPersonal: 'all',
      myChart: {},
      member_count: [],
      pieName: [],
      pieData: [],
      myChartStyle: { float: 'left', width: '100%', height: '900px' }, // 图表样式
      member_count_chooise_date: '',
      filter_member_count: '',
      customerChart: {},
      customer_count: [],
      customer_pieName: [],
      customer_pieData: [],
      needChatId: '',
      chatTotal: 0,
      chatOur: 0,
      chatCustomer: 0,
      chatRobot: 0,
      serviceInDrawer: false,
      uploadHeader: { Authorization: localStorage.token },
      selectId: null,
      selectName: '',
      chatMessages: [],
      contentchange: false,
      searchArr: {
        msgtype: '',
        betweenDate: '',
        msgtime: '',
        content: ''
      },
      msgPageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      messageLoading: false,
      toBottom: false,
      avtiveChat: null,
      videoVisible: false,
      videoSrc: '',
      complete: false,
      itemDrawer: false,
      licenseList: [],
      formData: null,
      itemForm: {
        is_allot: '1',
        user_id: null,
        handle_time: null,
        place_id: null,
        company_id: null,
        order_id: null,
        entries_type: null,
        item_content: '',
        cates: []
      },
      loading: false,
      companies: [],
      orders: [],
      users: [],
      places: [],
      options: [],
      itemContent: [],
      selectCom: [],
      is_checked: false,
      itemFiles: [],
      fileDrawer: false,
      upForm: {
        cid: null,
        file_type: null,
        file_source: null,
        remark: ''
      },
      upRules: {
        cid: [{ required: true, message: '请选择公司', trigger: 'blur' }],
        file_type: [
          { required: true, message: '请选择文件类型', trigger: 'blur' }
        ],
        file_source: [
          { required: true, message: '请选择文件来源', trigger: 'blur' }
        ]
      },
      checkArr: [],
      chatInfoDrawer: false,
      groupInfo: [],
      ownerName: ''
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },
    typeInPickerOptions: function () {
      var _this = this
      return {
        shortcuts: [
          {
            text: '今天',
            onClick (picker) {
              const todayDate = new Date().toLocaleDateString()
              var dateArr = _this.nowDate(todayDate)
              const start = new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                0,
                0,
                0
              )
              const end = new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                23,
                59,
                59
              )
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '昨天',
            onClick (picker) {
              const dd = new Date()
              dd.setDate(dd.getDate() - 1)
              var yesterDate = dd.toLocaleDateString()
              var dateArr = _this.nowDate(yesterDate)
              const start = new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                0,
                0,
                0
              )
              const end = new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                23,
                59,
                59
              )
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本周',
            onClick (picker) {
              var now = new Date()
              const year = now.getFullYear()
              const month = now.getMonth()
              const day = now.getDate()
              const week = now.getDay()

              let start = new Date(year, month, day - week + 1, 0, 0, 0)
              let end = new Date(year, month, day - week + 7, 23, 59, 59)

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上周',
            onClick (picker) {
              var dateS = _this.getWeek(-1, 0).split('-')
              var dateE = _this.getWeek(-1, 1).split('-')

              let start = new Date(dateS[0], dateS[1] - 1, dateS[2], 0, 0, 0)
              let end = new Date(dateE[0], dateE[1] - 1, dateE[2], 23, 59, 59)

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本月',
            onClick (picker) {
              var str = _this.getCurrentDate()

              var arr = _this.getfirstDateAndlastDate(str)

              var arrS = arr[0].split('-')
              var arrE = arr[1].split('-')

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0)
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59)

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上个月',
            onClick (picker) {
              var str = _this.fromLastMonth()

              var arr = _this.getfirstDateAndlastDate(str)

              var arrS = arr[0].split('-')
              var arrE = arr[1].split('-')

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0)
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59)

              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  watch: {
    betweenDate: function (val) {
      this.searchArr.betweenDate = val || ''
    },
    chatId: function (val) {
      this.toBottom = true
      this.msgPageOption.currentPage = 1
      this.messageLoading = false
      this.chatMessages = []
      this.itemContent = []
      this.selectId = val || null
      this.searchArr.msgtype = ''
      if (val) this.getMessages(val, false)
    },
    chatName: function (val) {
      this.selectName = val || null
      if (val) {
        this.getCompanyId(val)
      }
    },
    'searchArr.msgtype': function (val) {
      this.toBottom = true
      this.msgPageOption.currentPage = 1
      this.messageLoading = false
      this.chatMessages = []
      this.itemContent = []
      this.getMessages(this.selectId, false)
    }
  },
  methods: {
    closeSelf () {
      this.errData = []
    },
    doBindOrderNum () {
      this.$axios.post('api/chat/bind_ordernum', {
        chat_id: this.chatId,
        order_num: this.dynamicValidateForm
      }).then(({ data }) => {
        if (data.code === 1) {
          this.bindDialog = false
          if (!data.data.length) {
            this.$message.success('绑定成功!')
          } else {
            this.errData = data.data
            this.infoDialog = true
          }
        }
      }).catch()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.doBindOrderNum()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    removeDomain (item) {
      var index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    addDomain () {
      this.dynamicValidateForm.domains.push({
        value: '',
        key: Date.now()
      })
    },
    openBindDialog () {
      this.bindDialog = true
    },
    clearSub () {
      var subLength = this.dynamicValidateForm.domains.length
      this.dynamicValidateForm.domains.splice(0, subLength)
      this.dynamicValidateForm.orderNum = ''
    },
    getCompanyId () {
      this.$axios
        .get('api/admin/userGroups/get_company_id?chat_id=' + this.chatId)
        .then(({ data }) => {
          if (data.code === 1) {
            this.getedCompanyId = data.data
            // console.log(this.getedCompanyId.length)
            // console.log(JSON.parse(JSON.stringify(this.getedCompanyId)))
          }
        })
        .catch()
    },
    handleOpenCompanyInfo (id) {
      if (!id) {
        this.$message.warning('未获取到公司信息！')
        return false
      }
      this.companyInfoDrawer = true
      this.$nextTick(() => {
        this.companyComId = id
      })
    },
    chooseChatType () {
      this.handleGetMemberCount()
    },
    nowDate (date) {
      return date.split('/')
    },
    getWeek (n, type) {
      // 周
      let now = new Date()
      let day = now.getDay() // 返回星期几的某一天;
      if (!type) {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber + 1)
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber - 7)
        } else {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber)
        }
      } else {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber + 1 + 6) // 在周开始的日期上+6天=周结束
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber - 7 + 6)
        } else {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber)
        }
      }
      let date = now.getDate()
      let month = now.getMonth() + 1

      let s =
        now.getFullYear() +
        '-' +
        (month < 10 ? '0' + month : month) +
        '-' +
        (date < 10 ? '0' + date : date)
      return s
    },
    getfirstDateAndlastDate (dateC) {
      var dateStr = dateC
      var date = new Date(dateStr)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month > 12) {
        month = 1
        year++
      }
      if (month < 10) {
        month = '0' + month
      }
      var monthLastDay = new Date(year, month, 0).getDate()
      var firstDate = year + '-' + month + '-' + '01'
      var lastDate = year + '-' + month + '-' + monthLastDay
      return [firstDate, lastDate]
    },
    getCurrentDate () {
      var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    fromLastMonth () {
      var date = new Date()
      var lastMonthDate = ''
      // 获取当前几号，如果小于10则补0
      var day = date.getDate()
      if (day < 10) {
        day = '0' + day
      }
      var month = date.getMonth()
      var year = date.getFullYear()
      // 上个月小于1则证明跨年，年份减1
      if (month < 1) {
        lastMonthDate = year - 1 + '-12-' + day
      } else {
        // 月份小于10则补0
        if (month < 10) {
          month = '0' + month
        }
        lastMonthDate = year + '-' + month + '-' + day
      }
      return lastMonthDate
    },
    getItemCates () {
      this.$axios.get('/api/item/cates').then(res => {
        let { data } = res
        if (data.code === 0) {
          this.options = data.data.cates
          this.users = data.data.users
          this.places = data.data.places
        }
      })
    },
    handelContentchange (val) {
      if (this.contentchange) return
      this.contentchange = true
      setTimeout(() => {
        this.searchMessages()
      }, 800)
    },
    searchMessages () {
      this.toBottom = true
      this.msgPageOption.currentPage = 1
      this.messageLoading = false
      this.chatMessages = []
      this.itemContent = []
      this.getMessages(this.selectId, false)
    },
    getMessages (id, isScroll) {
      if (isScroll) this.oldHeight = this.$refs.messagesList.$el.scrollHeight
      this.$axios
        .get(
          '/api/admin/userGroups/' +
          id +
          '?page=' +
          this.msgPageOption.currentPage +
          this.searchStr
        )
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.chatMessages.unshift(...data.data.messages)
            if (this.msgPageOption.currentPage === 1) this.messageLoading = true
            this.$nextTick(() => {
              if (this.toBottom) {
                setTimeout(() => {
                  this.$refs.messagesList.$el.scrollTop = this.$refs.messagesList.$el.scrollHeight
                }, 500)
              }
            })
            this.contentchange = false
            this.complete = data.data.messages.length === 0
            if (data.data.companies.length > 0) {
              this.selectName = this.getCompaniesName(data.data.companies)
              this.selectCom = data.data.companies
            } else {
              this.selectCom = []
            }
          }
        })
    },
    handelSearch (type) {
      this.searchArr.msgtype = type
    },
    getCompaniesName (companies) {
      let str = ''
      for (var i = 0; i < companies.length; i++) {
        str += companies[i].company_name + ' '
      }
      return str
    },
    scrollBottom () {
      let scrollTop = this.$refs.messagesList.$el.scrollTop

      if (scrollTop === 0 && this.messageLoading) {
        if (!this.complete) this.msgPageOption.currentPage++
        this.toBottom = false
        this.getMessages(this.selectId, true)
        setTimeout(() => {
          let newHeight = this.$refs.messagesList.$el.scrollHeight
          this.$refs.messagesList.$el.scrollTop = newHeight - this.oldHeight
        }, 500)
      }
    },
    handLoadMedia (index, row, ext) {
      if (row.filesrc) return

      this.$message.error('文件未下载完成，请稍后再试')

      // this.$axios.put('/api/admin/chatdata/' + row.id, {ext: ext})
      //   .then((res) => {
      //     let { data } = res
      //     if (data.code === 0) {
      //       this.chatMessages[index].filesrc = data.data.url
      //     }
      //   })
    },
    handLoadAmr (index, row, ext) {
      if (row.filesrc) {
        this.playVoice(row.filesrc, index)
        return
      }

      this.$message.error('文件未下载完成，请稍后再试')

      // this.$axios.put('/api/admin/chatdata/' + row.id, {ext: ext})
      //   .then((res) => {
      //     const { data } = res
      //     if (data.code === 0) {
      //       this.chats[index].filesrc = data.data.url
      //       this.playVoice(data.data.url, index)
      //     } else {
      //       this.$message.error(data.msg)
      //     }
      //   })
    },
    playVoice (name, index) {
      let that = this
      if (that.avtiveChat !== null) {
        amr.stop()
        return
      }

      amr = new BenzAMRRecorder()
      amr.initWithUrl(name).then(function () {
        that.avtiveChat = index
        amr.play()
      })
      amr.onEnded(function () {
        that.avtiveChat = null
        console.log('播放完毕')
      })
    },
    handLoadFile (index, row) {
      if (row.filesrc) {
        window.open(row.filesrc)
        return
      }

      this.$message.error('文件未下载完成，请稍后再试')

      // this.$axios.put('/api/admin/chatdata/' + row.id, {ext: 'files', fileName: row.filename})
      //   .then((res) => {
      //     const { data } = res
      //     if (data.code === 0) {
      //       this.chatRecord[index].filesrc = data.data.url
      //       window.location.href = data.data.url
      //     } else {
      //       this.$message.error(data.msg)
      //     }
      //   })
    },
    handLoadVideo (index, row, ext) {
      if (row.filesrc) {
        this.videoPlay(row.filesrc)
        return
      }

      this.$message.error('文件未下载完成，请稍后再试')

      // this.$axios.put('/api/admin/chatdata/' + row.id, {ext: ext})
      //   .then((res) => {
      //     let { data } = res
      //     if (data.code === 0) {
      //       this.chatMessages[index].filesrc = data.data.url
      //       this.videoPlay(data.data.url)
      //     }
      //   })
    },
    videoPlay (src) {
      this.videoSrc = src
      this.videoVisible = true
    },
    handleVideoClose (done) {
      this.videoSrc = ''
      done()
    },
    getFileName () {
      let str = ''
      for (var i = 0; i < this.itemFiles.length; i++) {
        str +=
          this.itemFiles[i].msgtype === 'image'
            ? 'image.png，'
            : this.itemFiles[i].filename + '，'
      }

      return str
    },
    handleAddFiles () {
      this.itemFiles = []
      if (this.itemContent.length > 0) {
        for (let j = 0; j < this.chatMessages.length; j++) {
          let isIn = this.itemContent.indexOf(this.chatMessages[j].msgid)
          if (isIn !== -1) {
            if (
              this.chatMessages[j].msgtype === 'image' ||
              this.chatMessages[j].msgtype === 'file'
            ) {
              if (!this.chatMessages[j].filesrc) {
                this.$message.error('所选文件包含未下载完成文件，无法添加')
                return
              }
              this.itemFiles.push(this.chatMessages[j])
            }
          }
        }
      }

      if (this.itemFiles.length === 0) {
        this.$message.error('请选择文件')
        return
      }

      this.companies = this.selectCom

      if (this.companies.length === 0) {
        this.$message.error('该群未绑定公司，无法添加材料')
        return
      }

      this.fileDrawer = true
    },
    handleAddFiles_new () {
      this.itemFiles = []
      if (this.itemContent.length > 0) {
        for (let j = 0; j < this.chatMessages.length; j++) {
          let isIn = this.itemContent.indexOf(this.chatMessages[j].msgid)
          if (isIn !== -1) {
            if (
              this.chatMessages[j].msgtype === 'image' ||
              this.chatMessages[j].msgtype === 'file'
            ) {
              if (!this.chatMessages[j].filesrc) {
                // this.$message.error('所选文件包含未下载完成文件，无法添加')
                return
              }
              setTimeout(() => {
                this.itemFiles.push(this.chatMessages[j])
              })
            }
          }
        }
      }

      if (this.itemFiles.length === 0) {
        // this.$message.error('请选择文件')
        return
      }

      // this.companies = this.selectCom

      if (this.companies.length === 0) {
        // this.$message.error('该群未绑定公司，无法添加材料')
        return false
      }

      // this.fileDrawer = true
    },
    submitAddFiles (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('/api/admin/userGroups/company_file', {
              upForm: this.upForm,
              itemFiles: this.itemFiles
            })
            .then(res => {
              let { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.setFileState(data.data.record)
                this.clearUpForm()
                this.fileDrawer = false
                this.$emit('changeFile')
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    setFileState (record) {
      for (let i = 0; i < this.itemFiles.length; i++) {
        let isIn = this.chatMessages.indexOf(this.itemFiles[i])
        if (isIn !== -1) {
          this.chatMessages[isIn].storage_record = record
        }
      }
    },
    clearUpForm () {
      this.companies = []
      this.itemFiles = []
      this.itemContent = []
      this.checkArr = []
      this.is_checked = false
      this.$refs['upForm'].resetFields()
    },
    handleAddFileClose (done) {
      this.clearUpForm()
      done()
    },
    handleAddItemEntry () {
      this.itemForm.item_content = ''
      if (this.itemContent.length > 0) {
        for (let j = 0; j < this.chatMessages.length; j++) {
          let isIn = this.itemContent.indexOf(this.chatMessages[j].msgid)
          if (isIn !== -1) {
            let name = '???'
            if (this.chatMessages[j].from_type === 1) {
              name = this.chatMessages[j].employee
                ? this.chatMessages[j].employee.name
                : '???'
            } else {
              name = this.chatMessages[j].external
                ? this.chatMessages[j].external.name
                : '???'
            }
            let megerStr =
              name +
              ' ' +
              this.chatMessages[j].msgtime +
              ': ' +
              this.chatMessages[j].content +
              ';' +
              '\n'
            setTimeout(() => {
              this.itemForm.item_content += megerStr
            })
          }
        }
      }
      setTimeout(() => {
        this.companies = this.selectCom
      })
      this.formData = new FormData()
      // this.itemDrawer = true
      this.handleAddFiles_new()
      this.serviceInDrawer = true
    },
    handleAddClose (done) {
      this.$refs['itemForm'].resetFields()
      this.licenseList = []
      done()
      this.formData = null
    },
    remoteCompanyMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchItemCompanys(query)
        }, 200)
      } else {
        this.companies = []
      }
    },
    searchItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.companies = data.data.companies
        }
      })
    },
    remoteOrderMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchOrders(query)
        }, 200)
      } else {
        this.orders = []
      }
    },
    searchOrders (query) {
      this.$axios.get('/api/admin/searchOldOrders?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.orders = data.data.orders
        }
      })
    },
    handleLicensePreview (file) { },
    handleLicenseChange (file, fileList) {
      this.licenseList = fileList
    },
    handleLicenseRemove (file, fileList) {
      this.licenseList = fileList
      this.formData = null
      this.formData = new FormData()
      this.licenseList.forEach(file => this.formData.append('file[]', file.raw))
      for (let key in this.itemForm) {
        this.formData.append(key, this.itemForm[key])
      }
    },
    handleParse (e) {
      let file = null
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf('image') > -1
      ) {
        file = e.clipboardData.items[0].getAsFile()
        let reader = new FileReader()
        reader.readAsDataURL(file)
        let that = this
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: 'ready',
            url: e.target.result
          }

          if (that.licenseList.length < 5) {
            that.licenseList.push(fileObj)
          } else {
            that.$message.error('最多可以上传5张')
          }
        }
      } else {
        this.$message.warning('上传的文件必须为图片')
      }
    },
    submitAddUpload (formName) {
      if (!this.itemForm.company_id) {
        this.$message.error('公司不能为空')
        return false
      }
      if (!this.itemForm.entries_type) {
        this.$message.error('事项类型不能为空')
        return false
      }
      if (this.itemForm.is_allot === '2' || this.itemForm.is_allot === 2) {
        if (!this.itemForm.user_id) {
          this.$message.error('办理人不能为空')
          return false
        }
        if (!this.itemForm.handle_time) {
          this.$message.error('办理时间不能为空')
          return false
        }
        if (
          this.itemForm.entries_type === 1 ||
          this.itemForm.entries_type === '1'
        ) {
          if (!this.itemForm.place_id) {
            this.$message.error('办理地点不能为空')
            return false
          }
        }
      }
      if (this.itemForm.cates.length === 0) {
        this.$message.error('事项分类不能为空')
        return false
      }
      if (!this.itemForm.item_content) {
        this.$message.error('内容详情不能为空')
        return false
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.licenseList.length > 0) {
            this.licenseList.forEach(file =>
              this.formData.append('file[]', file.raw)
            )
          }
          for (let key in this.itemForm) {
            this.formData.append(key, this.itemForm[key])
          }
          this.$axios
            .post('/api/item/store', this.formData, this.itemForm.cates)
            .then(res => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.itemDrawer = false
                this.itemForm.company_id = null
                this.itemForm.order_id = null
                this.itemForm.place_id = null
                this.itemForm.cates = []
                this.itemForm.entries_type = null
                this.itemForm.is_allot = '1'
                this.itemForm.user_id = null
                this.itemForm.handle_time = null
                this.itemForm.item_content = []
                this.is_checked = false
                this.licenseList = []
                this.itemContent = []
                this.getMessages(this.selectId, false)
              }
            })
        }
      })
    },
    handleAddMessageIndex (index) {
      console.log('ann')
      let status = this.itemContent.indexOf(index)
      if (status === -1) {
        this.itemContent.push(index)
      } else {
        this.itemContent.splice(this.itemContent.indexOf(index), 1)
      }
    },
    handleChatInfoOpen () {
      this.$axios.get('/api/admin/group_info/' + this.selectId).then(res => {
        let { data } = res
        if (data.code === 0) {
          this.groupInfo = data.data.group
          this.needChatId = data.data.group.chat_id
          this.handleGetMemberCount()
          this.getOwnerName()

          if (!data.data.info.errcode) {
            if (!this.groupInfo.notice) {
              if (data.data.info.notice) {
                this.groupInfo.notice = data.data.info.notice
              }
            }
          }

          this.chatInfoDrawer = true
        }
      })
    },
    initDate () {
      for (let i = 0; i < this.member_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        this.pieName[i] = this.member_count[i].real_name != null ? this.member_count[i].real_name.name : ''
        this.pieData[i] = {
          name: this.member_count[i].real_name != null ? this.member_count[i].real_name.name : '',
          value: this.member_count[i].member_count
        }
      }
    },
    initEcharts () {
      // 饼图
      const option = {
        tooltip: {
          // 提示框组件
          trigger: 'item', // 触发类型,'item'数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。 'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
          triggerOn: 'mousemove', // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          triggerOff: 'mousemout', // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          showContent: true, // 是否显示提示框浮层
          alwaysShowContent: false, // 是否永远显示提示框内容
          showDelay: 0, // 浮层显示的延迟，单位为 ms
          hideDelay: 100, // 浮层隐藏的延迟，单位为 ms
          enterable: false, // 鼠标是否可进入提示框浮层中
          confine: false, // 是否将 tooltip 框限制在图表的区域内
          transitionDuration: 0.4, // 提示框浮层的移动动画过渡时间，单位是 s,设置为 0 的时候会紧跟着鼠标移动
          // position: ['50%', '50%'], // 提示框浮层的位置，默认不设置时位置会跟随鼠标的位置,[10, 10],回掉函数，inside鼠标所在图形的内部中心位置，top、left、bottom、right鼠标所在图形上侧，左侧，下侧，右侧，
          // formatter: '{b0}: {c0}<br />{b1}: {c1}', // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式,模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等
          formatter: '{b} : {c} <br/>百分比 : {d}%', // {a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）
          backgroundColor: 'transparent', // 标题背景色
          borderColor: '#ccc', // 边框颜色
          borderWidth: 0, // 边框线宽
          padding: 5 // 图例内边距，单位px  5  [5, 10]  [5,10,5,10]
          // textStyle: mytextStyle // 文本样式
        },
        legend: {
          // 图例
          data: this.pieName,
          right: '0%',
          top: '10%',
          orient: 'vertical'
        },
        // title: {
        //   // 设置饼图标题，位置设为顶部居中
        //   text: '聊天记录统计',
        //   top: '0%',
        //   left: 'center'
        // },
        series: [
          {
            type: 'pie',
            label: {
              show: true,
              formatter: '{b} : {c} ({d}%)' // b代表名称，c代表对应值，d代表百分比
            },
            radius: '45%', // 饼图半径
            center: ['40%', '35%'], // 饼图位置 左右,上下
            data: this.pieData
          }
        ]
      }
      console.log(this.seriesData)
      const optionFree = {
        xAxis: {},
        yAxis: {},
        series: [
          {
            data: this.seriesData,
            type: 'line',
            smooth: true
          }
        ]
      }
      console.log(optionFree)
      this.myChart = echarts.init(document.getElementById('mychart'))
      this.myChart.setOption(option)
      // 随着屏幕大小调节图表
      window.addEventListener('resize', () => {
        this.myChart.resize()
      })
    },
    initDate_customer () {
      for (let i = 0; i < this.customer_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        this.customer_pieName[i] = this.customer_count[i].real_name != null ? this.customer_count[i].real_name.name : ''
        this.customer_pieData[i] = {
          name: this.customer_count[i].real_name != null ? this.customer_count[i].real_name.name : '',
          value: this.customer_count[i].member_count
        }
      }
    },
    initEcharts_customer () {
      // 饼图
      const option1 = {
        tooltip: {
          // 提示框组件
          trigger: 'item', // 触发类型,'item'数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。 'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
          triggerOn: 'mousemove', // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          triggerOff: 'mousemout', // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          showContent: true, // 是否显示提示框浮层
          alwaysShowContent: false, // 是否永远显示提示框内容
          showDelay: 0, // 浮层显示的延迟，单位为 ms
          hideDelay: 100, // 浮层隐藏的延迟，单位为 ms
          enterable: false, // 鼠标是否可进入提示框浮层中
          confine: false, // 是否将 tooltip 框限制在图表的区域内
          transitionDuration: 0.4, // 提示框浮层的移动动画过渡时间，单位是 s,设置为 0 的时候会紧跟着鼠标移动
          // position: ['50%', '50%'], // 提示框浮层的位置，默认不设置时位置会跟随鼠标的位置,[10, 10],回掉函数，inside鼠标所在图形的内部中心位置，top、left、bottom、right鼠标所在图形上侧，左侧，下侧，右侧，
          // formatter: '{b0}: {c0}<br />{b1}: {c1}', // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式,模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等
          formatter: '{b} : {c} <br/>百分比 : {d}%', // {a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）
          backgroundColor: 'transparent', // 标题背景色
          borderColor: '#ccc', // 边框颜色
          borderWidth: 0, // 边框线宽
          padding: 5 // 图例内边距，单位px  5  [5, 10]  [5,10,5,10]
          // textStyle: mytextStyle // 文本样式
        },
        legend: {
          // 图例
          data: this.customer_pieName,
          right: '0%',
          top: '10%',
          orient: 'vertical'
        },
        // title: {
        //   // 设置饼图标题，位置设为顶部居中
        //   text: '聊天记录统计',
        //   top: '0%',
        //   left: 'center'
        // },
        series: [
          {
            type: 'pie',
            label: {
              show: true,
              formatter: '{b} : {c} ({d}%)' // b代表名称，c代表对应值，d代表百分比
            },
            radius: '45%', // 饼图半径
            center: ['40%', '35%'], // 饼图位置 左右,上下
            data: this.customer_pieData
          }
        ]
      }
      // console.log(this.seriesData)
      const optionFree1 = {
        xAxis: {},
        yAxis: {},
        series: [
          {
            data: this.seriesData,
            type: 'line',
            smooth: true
          }
        ]
      }
      console.log(optionFree1)
      this.customerChart = echarts.init(
        document.getElementById('customer_chart')
      )
      this.customerChart.setOption(option1)
      // 随着屏幕大小调节图表
      window.addEventListener('resize', () => {
        this.customerChart.resize()
      })
    },
    HandleFilterMemberCount (val) {
      this.pieData = []
      this.pieName = []
      this.HandleFilterMemberCount_customer(val)
      for (let i = 0; i < this.member_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        if (this.member_count[i].member_count >= val) {
          this.pieName[i] = this.member_count[i].real_name != null ? this.member_count[i].real_name.name : ''
          this.pieData[i] = {
            name: this.member_count[i].real_name != null ? this.member_count[i].real_name.name : '',
            value: this.member_count[i].member_count
          }
        }
      }
      this.initEcharts()
    },
    HandleFilterMemberCount_customer (val) {
      this.customer_pieData = []
      this.customer_pieName = []
      for (let i = 0; i < this.customer_count.length; i++) {
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        if (this.customer_count[i].member_count >= val) {
          this.customer_pieName[i] = this.customer_count[i].real_name != null ? this.customer_count[i].real_name.name : ''
          this.customer_pieData[i] = {
            name: this.customer_count[i].real_name != null ? this.customer_count[i].real_name.name : '',
            value: this.customer_count[i].member_count
          }
        }
      }
      this.initEcharts_customer()
    },
    handleGetMemberCount () {
      this.pieData = []
      this.pieName = []
      this.member_count = []
      this.chatTotal = 0
      this.chatOur = 0
      this.chatCustomer = 0
      this.chatRobot = 0
      this.customer_pieData = []
      this.customer_pieName = []
      this.$axios
        .get(
          'api/admin/member_count?date=' +
          this.member_count_chooise_date +
          '&chatId=' +
          this.needChatId +
          '&type=' +
          this.groupOrPersonal
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.chatTotal = data.count.total
            this.member_count = data.data
            this.customer_count = data.customer
            this.chatOur = data.count.our
            this.chatCustomer = data.count.customer
            // this.chatRobot = data.count.robot
            this.initDate() // 数据初始化
            this.initEcharts()
            this.initDate_customer() // 数据初始化
            this.initEcharts_customer()
          }
        })
        .catch()
    },
    setProxyType () {
      let option = {
        title: {
          text: '代理记账需求（有效客户）（' + this.proxyTotal + '）'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: this.proxyHeader
        },
        series: [
          {
            name: '代理记账需求',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.proxyCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        color: ['#5787FF', '#C8E0FF', '#FFD8B4', '#AEA1FB']
      }
      this.proxyChart.setOption(option)
    },
    handleChatInfoClose (done) {
      this.groupOrPersonal = 'all'
      this.filter_member_count = ''
      this.member_count_chooise_date = ''
      this.groupInfo = []
      this.ownerName = ''
      done()
    },
    getOwnerName () {
      for (var i = 0; i < this.groupInfo.members.length; i++) {
        if (this.groupInfo.owner === this.groupInfo.members[i].member_userid) {
          this.ownerName = this.groupInfo.members[i].name
        }
      }
    },
    getJoinType (row) {
      let str = ''
      if (row.join_scene < 3) {
        str = '由 ' + (row.employee ? row.employee.name : '成员') + ' 邀请入群'
      } else {
        str = '通过扫描群二维码入群'
      }

      return str
    },
    msgHead (msg) {
      let src = ''

      if (msg.from_type === 1 && msg.employee) {
        src = msg.employee.thumb_avatar
      } else if (msg.external) {
        src = msg.external.avatar
      }

      return src
    },
    msgNickName (msg) {
      let name = '未添加好友客户'
      if (msg.from_type === 1 && msg.employee) {
        name = msg.employee.name
      } else if (msg.external) {
        name = msg.external.name
      }

      return name
    },
    closeDrawer () {
      this.serviceInDrawer = false
    }
  },
  mounted () {
    this.getItemCates()
  }
}
</script>

<style lang="stylus" scoped>
.mt-pd-2 {
  margin-top: 0.2rem;
  padding: 0 0.2rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
}

.wxWorkChat >>> .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 0.5rem;
}

.wxWorkChat >>> .video {
  background-color: #606266 !important;
  color: #fff !important;
}

.el-form .el-select {
  width: 100%;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}

.wxWorkChat {
  .hide-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ml-10 {
    margin-left: 0.2rem;
  }

  .p-10 {
    padding: 0.2rem;
  }

  .text-align-c {
    text-align: center;
  }

  .chat_content {
    width: 100%;
    min-height: calc(100vh - 210px);
    height: 6rem;
    border: solid 1px #DCDFE6;
    border-radius: 5px;
    border-bottom: none;
    overflow: auto;

    .chat_record_wrap {
      height: 100%;
      overflow: auto;

      .record_item {
        display: flex;
        justify-content: flex-start;
        padding: 0.2rem;

        .record_wrap {
          display: flex;
          align-items: center;

          .reciver {
            padding: 0.2rem;
            background: #e5eeea;
          }

          .sender {
            background: #9eea6a;
          }

          .record {
            margin-top: 0.06rem;
            display: inline-block;
          }
        }

        .record_time {
          color: #888;
          line-height: 1.5;
        }
      }

      .sender_item {
        justify-content: flex-end;
      }

      .sender_item .record_wrap {
        flex-direction: row-reverse;
      }

      .sender_item>.record_user_head {
        order: 1;
        margin-left: 0.2rem;
      }

      .sender_item .record_time, .sender_item .record_usernick, .sender_item>.record_time {
        text-align: right;
      }
    }
  }

  .recordText {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    line-height: 1.5;
    color: #555;
  }

  .messages-list {
    min-height: calc(100vh - 210px);
    height: 6rem;
    border: solid 1px #DCDFE6;
    border-radius: 5px;
    border-bottom: none;
    overflow-y: auto;

    .messages-con {
      padding: 0.4rem;

      .message {
        padding: 0.2rem;
      }

      .image_con {
        padding: 0.2rem;
      }
    }
  }

  .msg-content {
    padding-top: 0.2rem;
    color: #ff6a00;
  }
}

.infinite-list-item {
  margin: 0.2rem 0.2rem 0.4rem 0.2rem;
}

.infinite-item-content {
  display: inline-block;
  margin-top: 0.2rem;
  padding: 0 0.36rem 0 0.36rem;
  line-height: 0.9rem;
  background-color: #eef0f5;
}

.infinite-item-voice {
  display: inline-block;
  width: 1rem;
  padding: 0 0.36rem 0 0.36rem;
  line-height: 0.7rem;
  background-color: rgb(191, 221, 253);
  cursor: pointer;
}

.infinite-item-title {
  padding-left: 0.2rem;
}

.infinite-item-file {
  width: 5rem;
  margin-top: 0.2rem;
  padding: 0.2rem 0.36rem;
  color: #FFF;
  background-color: #eef0f5;
  cursor: pointer;
}

.infinite-file-icon {
  padding: 0.2rem 0.12rem 0.2rem 0.12rem;
  font-size: 0.5rem;
  background-color: #1a61a8;
}

.infinite-file-name {
  padding-left: 0.2rem;
  text-align: right;
  color: #333;
}

.infinite-file-size {
  text-align: right;
  margin-top: 19px;
  font-size: 12px;
}

.hide-style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.popper__arrow {
  position: absolute;
  top: 0.04rem;
  left: 0.36rem;
  display: block;
  margin-right: 0.06rem;
  border-color: transparent;
  border-style: solid;
  border-width: 0.18rem;
  border-top-width: 0;
  border-bottom-color: #eef0f5;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}

.imgType {
  width: 2rem;
  cursor: pointer;
}

.imgerr {
  width: 4rem;
  height: 2rem;
  cursor: pointer;
}

.wrap {
  position: relative;
  width: 20px;
  height: 20px;
  margin: 0.1rem auto;
}

.box {
  position: absolute;
  width: 17px;
  height: 17px;
  left: 0;
  bottom: 0;
  background: #333;
  border-top-right-radius: 15px;
  transform: rotateZ(45deg);
  -webkit-transform: rotateZ(45deg);
}

.box-an {
  animation: obox linear 0.8s 5000;
}

@keyframes obox {
  0% {
    background: #333;
  }

  33% {
    background: #333;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #333;
  }
}

@keyframes obox {
  0% {
    background: #333;
  }

  33% {
    background: #333;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #333;
  }
}

.box1 {
  position: absolute;
  width: 15px;
  height: 15px;
  background-color: #bfddfd;
  left: 0;
  bottom: 0;
  border-top-right-radius: 15px;
}

.box2 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 12px;
  height: 12px;
  background: #333;
  border-top-right-radius: 15px;
}

.box2-an {
  animation: obox2 linear 1s 5000;
}

@keyframes obox2 {
  0% {
    background: #333;
  }

  33% {
    background: #333;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #333;
  }
}

@keyframes obox2 {
  0% {
    background: #333;
  }

  33% {
    background: #333;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #333;
  }
}

.box3 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 9px;
  height: 9px;
  background-color: #bfddfd;
  border-top-right-radius: 15px;
}

.box4 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 6px;
  height: 6px;
  background: #333;
  border-top-right-radius: 15px;
}

.link {
  width: 300px;
}

.link >>> .el-card__header {
  padding: 0.2rem;
}

.link >>> .el-card__body {
  padding: 0.2rem;
}

.link >>> .el-divider--horizontal {
  margin: 0.2rem 0 0.1rem 0;
}

.link >>> .el-divider {
  background-color: #d46d5c;
}

.link-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 2;
  -moz-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}
.el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner {
  width: 360px !important;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon {
  font-size: 0.8rem;
}

.fs-s {
  font-size: medium;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/common/WxWorkChat.vue